import { z } from "zod";
export const npdProductDetailsDtoSchema = z.object({
    serveSize: z.number(),
    serveUnit: z.string(),
    batchQuantity: z.number(),
    batchUnit: z.string(),
    density: z.number(),
});
